import React from 'react';

import { SideNavigationItem, type SideNavigationItemProps } from '@lumapps/lumx-back-office/components/SideNavigation';
import { mdiAccountMultiple } from '@lumapps/lumx/icons';
import { useTranslate, GLOBAL } from '@lumapps/translations';

import { siteGroupsRoute } from '../../routes';

export interface GroupsSideNavigationProps extends Partial<SideNavigationItemProps> {
    isAllowed: boolean;
}

const GroupsSideNavigation: React.FC<GroupsSideNavigationProps> = ({ isAllowed, ...restOfProps }) => {
    const { translateKey } = useTranslate();

    if (!isAllowed) {
        return null;
    }

    return (
        <SideNavigationItem
            {...restOfProps}
            label={translateKey(GLOBAL.SITE_GROUPS)}
            icon={mdiAccountMultiple}
            route={siteGroupsRoute}
        />
    );
};

GroupsSideNavigation.displayName = 'SideNavigationItem';

export { GroupsSideNavigation };
